import React, { useContext } from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import ButtonBase from "@mui/material/ButtonBase";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { useLocation, useNavigate } from "react-router-dom";

import { ProVerContext, UserContext } from "../../context/userContext";
import { ProVerContextInfo, UserLoginInfo } from "../../types/context";
import { appLogger } from "../../utils";
import {
  enableChatbot,
  enableFeedback,
  enableBugReport,
  enableFeatureRequest,
} from "../../utils/config";

interface CountGridTile {
  total: number;
  avg: number;
  data: Object;
}
interface CountGridTileProps {
  bugReportChartData: any;
  ratingChartData: any;
  UserCountsBugsData: any;
  UserCountsFBData: any;
  UserCountsFeatureReqData: any;
  FeatureReqChartData: any;
}

const CountGridTile = (props: CountGridTileProps) => {
  appLogger.info({
    infoObj: {
      method: "CountGridTile",
      component: "dashboard",
      fileName: "CountGridTile.tsx",
      props: props,
    },
  });
  const {
    bugReportChartData,
    ratingChartData,
    FeatureReqChartData,
    UserCountsFBData,
    UserCountsBugsData,
    UserCountsFeatureReqData,
  } = props;
  const navigate = useNavigate();

  const { userInfo, setFilterDate } = useContext(UserContext) as UserLoginInfo;

  const goToPage = (type: string) => {
    appLogger.info({
      infoObj: {
        method: "goToPage",
        component: "dashboard",
        fileName: "CountGridTile.tsx",
        type: type,
      },
    });
    setFilterDate({
      startDate: "",
      endDate: "",
    });
    const stateObj = {
      pageType: type,
      insight: "",
      keyName: "",
      keyWordType: "",
    };
    navigate("/feedback", { state: stateObj });
  };
  let userEnabledFeatures: any = localStorage.getItem("userenabledFeatures");
  // console.log(JSON.parse(userEnabledFeatures), "userEnabledFeatures");
  if (userEnabledFeatures) {
    userEnabledFeatures = JSON.parse(userEnabledFeatures);
  }
  return (
    <>
      <Grid className="feedback-bug-filter dashboard" container spacing={2}>
        {enableFeedback && userEnabledFeatures?.enableFeedback && (
          <Grid item xs>
            <Paper
              className="count-grid-tile dashboard"
              sx={{
                pr: 1,
                margin: "auto",
                //maxWidth: 500,
                flexGrow: 1,
                backgroundColor: (theme) =>
                  theme.palette.mode === "dark" ? "#1A2027" : "#fff",
              }}
            >
              <Grid container spacing={2}>
                <Grid item>
                  <ButtonBase
                    className="count-grid-icon-fb"
                    sx={{ width: 70, height: 80 }}
                  >
                    <i className="icon-feedback count-grid-i-icon-fb" />
                  </ButtonBase>
                </Grid>
                <Grid item xs={12} sm container sx={{ alignItems: "center" }}>
                  <Grid item xs sx={{ display: "flex", alignItems: "center" }}>
                    <Grid item sx={{ pl: 0, fontSize: 12 }}>
                      <Typography
                        variant="subtitle1"
                        component="span"
                        sx={{ lineHeight: 1.5 }}
                      >
                        <div className="count-grid-tile-count">
                          <span>Feedback - &nbsp;</span>
                          <span className="test">{ratingChartData.total} </span>
                        </div>
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ fontSize: 11 }}
                        style={{
                          display: "flex",
                          alignItems: "baseline",
                          color: "#20212470",
                        }}
                      >
                        Unique Users - &nbsp;
                        <span className="count-users">
                          {UserCountsFBData?.countData?.uniqCountData?.total ||
                            0}
                        </span>
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ fontSize: 11 }}
                        style={{
                          display: "flex",
                          alignItems: "baseline",
                          color: "#20212470",
                        }}
                      >
                        Anonymous Users - &nbsp;
                        <span className="count-users">
                          {UserCountsFBData?.countData?.anonyCountData?.total ||
                            0}
                        </span>
                      </Typography>
                    </Grid>
                    <Typography
                      id="view-all-feedback-page"
                      className="card-veiwall"
                      variant="body2"
                      sx={{
                        mt: "auto",
                        ml: "auto",
                        fontSize: 9,
                        display: "flex",
                        alignItems: "flex-end",
                        color: "#0157ff",
                        p: 0,
                        cursor: "pointer",
                      }}
                      component="div"
                      onClick={() => goToPage("FEEDBACK")}
                    >
                      View All <KeyboardDoubleArrowRightIcon />
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        )}
        {((enableBugReport && userEnabledFeatures?.enableBugReport) ||
          (enableChatbot && userEnabledFeatures?.enableChatbot)) && (
          <Grid item xs>
            <Paper
              className="count-grid-tile dashboard"
              sx={{
                pr: 1,
                margin: "auto",
                //maxWidth: 500,
                flexGrow: 1,
                backgroundColor: (theme) =>
                  theme.palette.mode === "dark" ? "#1A2027" : "#fff",
              }}
            >
              <Grid container spacing={2}>
                <Grid item>
                  <ButtonBase
                    className="count-grid-icon-bug"
                    sx={{ width: 70, height: 80 }}
                  >
                    <i className="icon-bug count-grid-i-icon-bug" />
                  </ButtonBase>
                </Grid>
                <Grid item xs={12} sm container sx={{ alignItems: "center" }}>
                  <Grid item xs sx={{ display: "flex", alignItems: "center" }}>
                    <Grid item sx={{ pl: 0, fontSize: 12 }}>
                      <Typography
                        variant="subtitle1"
                        component="span"
                        sx={{ lineHeight: 1.5 }}
                      >
                        <div className="count-grid-tile-count">
                          <span>Tickets - &nbsp;</span>
                          <span className="test">
                            {" "}
                            {bugReportChartData.total}{" "}
                          </span>
                        </div>
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ fontSize: 11 }}
                        style={{
                          display: "flex",
                          alignItems: "baseline",
                          color: "#20212470",
                        }}
                      >
                        Unique Users - &nbsp;
                        <span className="count-users">
                          {UserCountsBugsData?.countData?.uniqCountData
                            ?.total || 0}
                        </span>
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ fontSize: 11 }}
                        style={{
                          display: "flex",
                          alignItems: "baseline",
                          color: "#20212470",
                        }}
                      >
                        Anonymous Users - &nbsp;
                        <span className="count-users">
                          {UserCountsBugsData?.countData?.anonyCountData
                            ?.total || 0}
                        </span>
                      </Typography>
                    </Grid>
                    <Typography
                      id="view-all-bug-page"
                      className="card-veiwall"
                      variant="body2"
                      sx={{
                        mt: "auto",
                        ml: "auto",
                        fontSize: 9,
                        display: "flex",
                        alignItems: "flex-end",
                        color: "#0157ff",
                        p: 0,
                        cursor: "pointer",
                      }}
                      component="div"
                      onClick={() => goToPage("BUG_REPORT")}
                    >
                      View All <KeyboardDoubleArrowRightIcon />
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        )}
        {enableFeatureRequest && userEnabledFeatures?.enableFeatureRequest && (
          <Grid item xs>
            <Paper
              className="count-grid-tile dashboard"
              sx={{
                pr: 1,
                margin: "auto",
                //maxWidth: 500,
                flexGrow: 1,
                backgroundColor: (theme) =>
                  theme.palette.mode === "dark" ? "#1A2027" : "#fff",
              }}
            >
              <Grid container spacing={2}>
                <Grid item>
                  <ButtonBase
                    className="count-grid-icon-fr"
                    sx={{ width: 70, height: 80 }}
                  >
                    <i className="icon-feature-request count-grid-i-icon-fr" />
                  </ButtonBase>
                </Grid>
                <Grid item xs={12} sm container sx={{ alignItems: "center" }}>
                  <Grid item xs sx={{ display: "flex", alignItems: "center" }}>
                    <Grid item sx={{ pl: 0, fontSize: 12 }}>
                      <Typography
                        variant="subtitle1"
                        component="span"
                        sx={{ lineHeight: 1.5 }}
                      >
                        <div className="count-grid-tile-count">
                          <span>Feature Request - &nbsp;</span>
                          <span className="test">
                            {" "}
                            {FeatureReqChartData.total}{" "}
                          </span>
                        </div>
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ fontSize: 11 }}
                        style={{
                          display: "flex",
                          alignItems: "baseline",
                          color: "#20212470",
                        }}
                      >
                        Unique Users - &nbsp;
                        <span className="count-users">
                          {UserCountsFeatureReqData?.countData?.uniqCountData
                            ?.total || 0}
                        </span>
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ fontSize: 11 }}
                        style={{
                          display: "flex",
                          alignItems: "baseline",
                          color: "#20212470",
                        }}
                      >
                        Anonymous Users - &nbsp;
                        <span className="count-users">
                          {UserCountsFeatureReqData?.countData?.anonyCountData
                            ?.total || 0}
                        </span>
                      </Typography>
                    </Grid>
                    <Typography
                      id="view-all-feature-page"
                      className="card-veiwall"
                      variant="body2"
                      sx={{
                        mt: "auto",
                        ml: "auto",
                        fontSize: 9,
                        display: "flex",
                        alignItems: "flex-end",
                        color: "#0157ff",
                        p: 0,
                        cursor: "pointer",
                      }}
                      component="div"
                      onClick={() => goToPage("FEATURE_REQUEST")}
                    >
                      View All <KeyboardDoubleArrowRightIcon />
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        )}
      </Grid>
      {/* /////// */}
    </>
  );
};

export default CountGridTile;
